import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FuseAlertModule } from '@fuse/components/alert';
import { KeycloakUser } from 'app/app.type';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakAdminService } from '../service/keycloak-admin.service';

@Component({
	selector: 'edit-user-modal',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatDialogModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatIconModule,
		FuseAlertModule
	],
	templateUrl: './edit-user-modal.component.html'
})
export class EditUserModalComponent {
	private readonly fb = inject(FormBuilder);
	private readonly dialogRef = inject(MatDialogRef<EditUserModalComponent>);

	keycloakAdminService = inject(KeycloakAdminService);

	editForm: FormGroup;
	saving = false;

	constructor(@Inject(MAT_DIALOG_DATA) public data: { user: KeycloakUser }) {
		this.editForm = this.fb.group({
			firstName: [data.user.firstName || ''],
			lastName: [data.user.lastName || ''],
			email: [data.user.email || '', [Validators.email]]
		});
	}

	cancel(): void {
		this.dialogRef.close();
	}

	save(): void {
		if (this.editForm.valid) {
			this.saving = true;

			const updatedUser: Partial<KeycloakUser> = {
				...this.data.user,
				firstName: this.editForm.value.firstName,
				lastName: this.editForm.value.lastName,
				email: this.editForm.value.email
			};

			this.keycloakAdminService.updateUser(updatedUser.id, updatedUser).subscribe((res) => {
				console.warn(res)
			})

			// Simular delay para mostrar loading
			setTimeout(() => {
				this.dialogRef.close(updatedUser);
			}, 1000);
		}
	}


}
